import { isDate, isSameDay, isSameYear, getYear } from 'date-fns'

export const NAME_OF_MONTH = {
    TH: [
        { id: 0, long: 'มกราคม', short: 'ม.ค.' },
        { id: 1, long: 'กุมภาพันธ์', short: 'ก.พ.' },
        { id: 2, long: 'มีนาคม', short: 'มี.ค.' },
        { id: 3, long: 'เมษายน', short: 'เม.ย.' },
        { id: 4, long: 'พฤษภาคม', short: 'พ.ค.' },
        { id: 5, long: 'มิถุนายน', short: 'มิ.ย.' },
        { id: 6, long: 'กรกฎาคม', short: 'ก.ค.' },
        { id: 7, long: 'สิงหาคม', short: 'ส.ค.' },
        { id: 8, long: 'กันยายน', short: 'ก.ย.' },
        { id: 9, long: 'ตุลาคม', short: 'ต.ค.' },
        { id: 10, long: 'พฤศจิกายน', short: 'พ.ย.' },
        { id: 11, long: 'ธันวาคม', short: 'ธ.ค.' },
    ],
    EN: [
        { id: 0, long: 'January', short: 'Jan' },
        { id: 1, long: 'February', short: 'Feb' },
        { id: 2, long: 'March', short: 'Mar' },
        { id: 3, long: 'April', short: 'Apr' },
        { id: 4, long: 'May', short: 'May' },
        { id: 5, long: 'June', short: 'Jun' },
        { id: 6, long: 'July', short: 'Jul' },
        { id: 7, long: 'August', short: 'Aug' },
        { id: 8, long: 'September', short: 'Sep' },
        { id: 9, long: 'October', short: 'Oct' },
        { id: 10, long: 'November', short: 'Nov' },
        { id: 11, long: 'December', short: 'Dec' },
    ],
}

// ex
// 2020-04-05 => 5 เม.ย. 2563 / 5 เมษายน 2563 / 5 Apr 2563 / 5 April 2563
type TFormatDate = {
    date: string // 2020-05-10
    lang?: 'TH' | 'EN'
    isShortMonth?: boolean
}
export const formatDate = ({ date, lang = 'TH', isShortMonth = false }: TFormatDate) => {
    if (isDate(new Date(date))) {
        const d: number = parseInt(date.split('-')[2])
        const m: number = parseInt(date.split('-')[1])
        const y: number = getYear(new Date(date))

        return `${d} ${NAME_OF_MONTH[lang][m - 1][isShortMonth ? 'short' : 'long']} ${lang === 'TH' ? y + 543 : y}`
    } else {
        return undefined
    }
}

// ex
// 2020-04-05 - 2021-04-05 => 5 เม.ย. 2563 - 5 เม.ย. 2564
// 2020-04-05 - 2020-05-10 => 5 เม.ย. - 10 พ.ค. 2563
// 2020-04-05 - 2020-04-10 => 5 - 10 เม.ย. 2563
// 2020-04-05 - 2020-04-05 => 5 เม.ย. 2563
type TFormatDateRange = {
    startDate?: string // 2020-05-10
    endDate?: string // 2020-05-10
    lang?: 'TH' | 'EN'
    isShortMonth?: boolean
}
export const formatDateRange = ({ startDate, endDate, lang = 'TH', isShortMonth = false }: TFormatDateRange) => {
    if (!startDate || !endDate || !isDate(new Date(startDate)) || !isDate(new Date(endDate))) {
        return undefined
    }

    if (isSameDay(new Date(startDate), new Date(endDate))) {
        // วันเดียวกัน
        return formatDate({ date: startDate, lang, isShortMonth })
    }

    if (isSameYear(new Date(startDate), new Date(endDate))) {
        // ปีเดียวกัน
        const sd: number = parseInt(startDate.split('-')[2])
        const sm: number = parseInt(startDate.split('-')[1])
        const sy: number = getYear(new Date(startDate))

        const ed: number = parseInt(endDate.split('-')[2])
        const em: number = parseInt(endDate.split('-')[1])

        if (sm === em) {
            // เดือนเดียวกัน
            return `${sd} - ${ed} ${NAME_OF_MONTH[lang][sm - 1][isShortMonth ? 'short' : 'long']} ${
                lang === 'TH' ? sy + 543 : sy
            }`
        } else {
            // คนละเดือน
            return `${sd} ${NAME_OF_MONTH[lang][sm - 1][isShortMonth ? 'short' : 'long']} - ${ed} ${
                NAME_OF_MONTH[lang][em - 1][isShortMonth ? 'short' : 'long']
            } ${lang === 'TH' ? sy + 543 : sy}`
        }
    } else {
        // คนละปี
        return `${formatDate({ date: startDate, lang, isShortMonth })} - ${formatDate({
            date: endDate,
            lang,
            isShortMonth,
        })}`
    }
}
